import React, { useState } from 'react'
import './AddPoints.css'
import { useSelector } from 'react-redux'
import { selectAppStyle, selectButtonStyle } from '../../reducers/StyleSlice'
import { selectData } from '../../AppSlice'

const AddPoints = ({
    player,
    handleAddPoints,
    setModalIsOpen,
}) => {

    

    const [points, setPoints] = useState('')

    const data = useSelector(selectData)
    const appStyle = useSelector(selectAppStyle)
    const buttonStyle = useSelector(selectButtonStyle)

  return (
    <div className='add-points'
        style={appStyle}
    >
        <div className='standard-div host-control' key={player.id}>
            <h4>{player.name}</h4>
            <form
                className='standard-div'
                onSubmit={(e)=> {
                    e.preventDefault()
                    handleAddPoints(player.id, points)
                    setPoints('')
                    setModalIsOpen(false)
                }}
            >
            {/* <label htmlFor='add-points'>Add Points:</label> */}
            <input 
                type='number' 
                id='add-points'
                value={points} 
                onChange={(e) => setPoints(e.target.value)} 
                inputMode='numeric'
                style={appStyle}
                placeholder='Enter Points To Add'
            />
            <div className='buttons'>
                <input 
                    type='submit' 
                    value='Add' 
                    style={data.is_active === false ? {
                        backgroundColor: 'var(--main-grey2)',
                        color: 'var(--main-black)',
                        textDecoration: 'line-through',
                        display: 'none'
                    } : buttonStyle}
                />
                <button
                    onClick={() => setModalIsOpen({
                        open: false,
                        method: ''
                    })}
                >Cancel</button>
            </div>
            </form>
        </div>
    </div>
  )
}

export default AddPoints